import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class DocumentoImpuestosTrasladosForm extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
      });
    }
  }

  rules(data) {
    const { TipoFactorDR, ObjetoImpDR } = data || {};

    let isExento = TipoFactorDR === 'Exento' && ObjetoImpDR !== '01';

    return {
      BaseDR: [
        'required',
        'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'
      ],
      ImpuestoDR: ['required'],
      TipoFactorDR: ['required'],
      TasaOCuotaDR: [isExento ? 'string' : 'required'],
      ImporteDR: [
        isExento ? 'string' : 'required',
        'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
      ],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      traslados: false,
      data: {}
    })
  }

  render() {
    const { isValid, data = {} } = this.state;

    const rules = this.rules(data);

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Base"
              name="BaseDR"
              placeholder=""
              help=""
              rules={ rules.BaseDR }
              value={ data.BaseDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Impuesto"
              name="ImpuestoDR"
              placeholder=""
              help=""
              minLength="21"
              maxLength="21"
              rules={ rules.ImpuestoDR }
              value={ data.ImpuestoDR }
              options={ ImpuestoDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Tipo Factor"
              name="TipoFactorDR"
              placeholder=""
              help=""
              minLength="21"
              maxLength="21"
              rules={ rules.TipoFactorDR }
              value={ data.TipoFactorDR }
              options={ TipoFactorDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Tasa O Cuota"
              name="TasaOCuotaDR"
              placeholder=""
              help=""
              rules={ rules.TasaOCuotaDR }
              value={ data.TasaOCuotaDR }
              options={ TasaOCuotaDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Importe"
              name="ImporteDR"
              placeholder=""
              help=""
              rules={ rules.ImporteDR }
              value={ data.ImporteDR }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar impuesto
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

const ImpuestoDR = [
  {
    label:'Selecciona',
    value: ''
  },
  {
    label:'IVA',
    value: '002'
  }
];

const TasaOCuotaDR = [
  {
    label:'Selecciona',
    value: ''
  },
  {
    label:'16',
    value: '0.160000'
  },
  {
    label:'8',
    value: '0.080000'
  },
  {
    label:'0',
    value: '0.000000'
  },
];

const TipoFactorDR = [
  {
    label:'Selecciona',
    value: ''
  },
  {
    label:'Tasa',
    value: 'Tasa'
  },
  {
    label:'Cuota',
    value: 'Cuota'
  },
  {
    label:'Exento',
    value: 'Exento'
  },
];

export default DocumentoImpuestosTrasladosForm;